import { Group, LoadingOverlay } from "@mantine/core";
import { useNavigate, useParams } from "react-router-dom";
import { useSessionStore } from "../../../stores/UserStore";
import { useEffect } from "react";
import { mainAxios } from "../../../api/axios";

const LoginOAuth = () => {
  const { provider } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const reseller = useSessionStore.getState().reseller;
    const params = window.location.href.split("?")?.[1];

    mainAxios
      .get(
        `https://${reseller.domain_redirect}/oauth/${provider}/callback?${params}`
      )
      .then((response) => {
        const { access_token, refresh_token } = response.data;
        useSessionStore.getState().setSession({ access_token, refresh_token });
        navigate("/");
      })
      .catch((err) => {
        navigate("/login?destination=/");
      });
  }, [provider]);

  return (
    <Group
      w={"100vw"}
      h={"100vh"}
      grow
      gap={0}
      justify="center"
    >
      <LoadingOverlay visible loaderProps={{ size: 64 }} />
    </Group>
  );
};

export default LoginOAuth;
